var card = {
    base: {
        boxSizing: "border-box",
        borderRadius: 3,
        p: 4,
        borderWidth: "1px",
        borderColor: "var(--card-border-color)",
        borderStyle: "solid",
        "--card-border-color": "white",
    },
    variants: {
        look: {
            solid: {
                backgroundColor: "var(--card-color-bg)",
                color: "var(--card-color-font)",
            },
        },
        tone: {
            primary: {
                "--colors-shadow": "var(--colors-primary-shadow)",
                "--card-color-bg": "var(--colors-primary-100)",
                "--card-color-font": "var(--colors-white)",
            },
            black: {
                "--colors-shadow": "var(--colors-black-shadow)",
                "--card-color-bg": "var(--colors-black-100)",
                "--card-color-font": "var(--colors-white)",
            },
            white: {
                "--colors-shadow": "var(--colors-black-shadow)",
                "--card-color-bg": "var(--colors-white)",
                "--card-color-font": "var(--colors-text)",
            },
            success: {
                "--colors-shadow": "var(--colors-success-shadow)",
                "--card-color-bg": "var(--colors-success-60)",
                "--card-color-font": "var(--colors-white)",
            },
            warning: {
                "--colors-shadow": "var(--colors-warning-shadow)",
                "--card-color-bg": "var(--colors-warning-60)",
                "--card-color-font": "var(--colors-white)",
            },
            critical: {
                "--colors-shadow": "var(--colors-critical-shadow)",
                "--card-color-bg": "var(--colors-critical-60)",
                "--card-color-font": "var(--colors-white)",
            },
        },
        border: {
            true: {
                "--card-border-color": "var(--colors-box-border)",
            },
        },
        elevation: {
            1: {
                boxShadow: 1,
            },
            2: {
                boxShadow: 2,
            },
            3: {
                boxShadow: 3,
            },
            4: {
                boxShadow: 4,
            },
            5: {
                boxShadow: 5,
            },
            6: {
                boxShadow: 6,
            },
        },
    },
};

export { card };
//# sourceMappingURL=card.js.map
